import * as actionTypes from './favoriteMediaConstants';
import {mediaHubItemsService} from '_app/services';

export const fetchFavoriteMedia = (selectedFilter, proxiedAsUserId) => (dispatch) => {
	dispatch(fetchFavoriteMediaRequest);

	return mediaHubItemsService
		.getFavoriteMedia(proxiedAsUserId)
		.then(response => dispatch(fetchFavoriteMediaSuccess(response.data, selectedFilter)))
		.catch(error => dispatch(fetchFavoriteMediaFailure(error)));
};

export const filterFavoriteMedia = selectedFilter => ({
	type: actionTypes.ON_FAVORITES_FILTER_CHANGE,
	selectedFilter
});

const fetchFavoriteMediaRequest = {
	type: actionTypes.FAVORITE_MEDIA_FETCH_REQUEST
};

const fetchFavoriteMediaSuccess = (data, selectedFilter) => ({
	type: actionTypes.FAVORITE_MEDIA_FETCH_SUCCESS,
	data,
	selectedFilter
});

const fetchFavoriteMediaFailure = error => ({
	type: actionTypes.FAVORITE_MEDIA_FETCH_FAILURE,
	errorInfo : error
});